var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-view-base-type-1',{attrs:{"value":_vm.value,"label":_vm.model.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }